export enum QuestionGroup {
  closed = "closed",
  open = "open",
  pages = "pages",
}
